import { microservicesApiAxios } from './api';
import {
  addCopyButton,
  configureTableColumns,
  scrollToPosition,
  displayErrorPopup,
  addLoadOrderDetailsButton,
} from './main';
import { addSpinner, addTableSpinner, removeSpinners } from './sidebar';
import { initDataTable } from './datatable';

export const rightNowQueueTableColumns = [
  { id: 'account_id', name: 'Account ID' },
  { id: 'action', name: 'Action' },
  { id: 'role_name', name: 'Role Name' },
  { id: 'created_at', name: 'Age' },
  { id: 'order_id', name: 'Order ID' },
];

function formatAge(isoTimestamp) {
  if (!isoTimestamp) return '-';

  const createdDate = new Date(isoTimestamp);
  const now = new Date();
  const diffMs = now - createdDate;

  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const totalHours = Math.floor(totalMinutes / 60);
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const minutes = totalMinutes % 60;

  return `${days} days ${hours} hours ${minutes} minutes`;
}

function createdCellAge(td, cellData, rowData, row, col) {
  const age = formatAge(cellData);
  $(td).text(age);

  // Add styling based on age
  if (cellData) {
    const createdDate = new Date(cellData);
    const now = new Date();
    const diffMs = now - createdDate;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (days > 2) {
      $(td).addClass('portal-danger');
    } else if (days > 1) {
      $(td).addClass('portal-warning');
    }
  }

  addCopyButton(td, cellData, rowData, row, col);
}

function createdCellAction(td, cellData, rowData, row, col) {
  $(td).text(cellData);

  if (cellData === 'create') {
    $(td).addClass('portal-success');
  }

  addCopyButton(td, cellData, rowData, row, col);
}

function createdCellOrder(td, cellData, rowData, row, col) {
  if (cellData && cellData !== '-') {
    const origin = window.location.origin;
    const orderUrl = `${origin}/?order_id=${cellData}#orderdetails`;
    $(td).html(`<a href="${orderUrl}" target="_blank">${cellData}</a>`);
  } else {
    $(td).text(cellData || '-');
  }

  addCopyButton(td, cellData, rowData, row, col);
  addLoadOrderDetailsButton(td);
}

export function initRightNowQueueTable(tableId) {
  configureTableColumns(tableId, rightNowQueueTableColumns);

  const columns = rightNowQueueTableColumns.map(col => ({
    visible: true,
    defaultContent: '-',
    orderable: true,
    searchable: true,
    type: 'string',
    data: col.id,
    name: `${col.id}_col`,
    title: col.name,
    createdCell:
      col.id === 'created_at'
        ? createdCellAge
        : col.id === 'action'
          ? createdCellAction
          : col.id === 'order_id'
            ? createdCellOrder
            : addCopyButton,
  }));

  initDataTable(
    tableId,
    [
      {
        extend: 'reloadTable',
        text: 'Reload List',
        ajaxReload: false,
        methodReload: loadRightNowQueueTable,
        titleAttr: 'Reload List',
      },
    ],
    columns,
    null,
    null,
  );
  loadRightNowQueueTable(tableId);
}

export async function loadRightNowQueueTable(tableId) {
  $(() => addSpinner());
  $(() => addTableSpinner());

  try {
    const items = await microservicesApiAxios.getIDCRightNowPortalQueueItems();
    const table = $('#' + tableId).DataTable();
    table.clear();
    table.rows.add(items);
    table.columns.adjust().draw();

    $(window).trigger('resize');
    scrollToPosition();
  } catch (e) {
    displayErrorPopup(e);
  } finally {
    removeSpinners();
  }
}
